import { useState } from 'react';
import './Header.css';
import Logo from '../Logo/Logo';
import { IconeFechar, IconeMenu, IconeWhatsApp } from '../Icones/Icones';
import { linkWhatsApp } from '../../config';

const LINKS = [
    { href: '#sistemas', texto: 'Sistemas' },
    { href: '#sob-demanda', texto: 'Sob demanda' },
    { href: '#quem-somos', texto: 'Quem somos' },
    { href: '#contato', texto: 'Contato' },
];

function Header() {
    const [menuAberto, setMenuAberto] = useState(false);
    const fecharMenu = () => setMenuAberto(false);

    return (
        <header className="header">
            <div className="container header-conteudo">
                <a href="#inicio" className="header-logo" aria-label="C1010 Sistemas, voltar ao início" onClick={fecharMenu}>
                    <Logo />
                </a>

                <button
                    type="button"
                    className="header-menu-botao"
                    aria-expanded={menuAberto}
                    aria-controls="menu-principal"
                    onClick={() => setMenuAberto(!menuAberto)}
                >
                    {menuAberto ? <IconeFechar /> : <IconeMenu />}
                    <span className="visualmente-oculto">{menuAberto ? 'Fechar menu' : 'Abrir menu'}</span>
                </button>

                <nav id="menu-principal" className={`header-nav ${menuAberto ? 'aberto' : ''}`} aria-label="Principal">
                    <ul>
                        {LINKS.map((link) => (
                            <li key={link.href}>
                                <a href={link.href} onClick={fecharMenu}>{link.texto}</a>
                            </li>
                        ))}
                    </ul>
                    <a
                        href={linkWhatsApp('Olá! Vim pelo site da C1010.')}
                        className="btn btn-primario header-whatsapp"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={fecharMenu}
                    >
                        <IconeWhatsApp tamanho={18} />
                        Falar no WhatsApp
                    </a>
                </nav>
            </div>
        </header>
    );
}

export default Header;
